import { createStyles } from '@zn-material-ui'

export default createStyles({
  containerStyle: {
    marginBottom: 50,
  },
  collapseStyle: {
    maxHeight: '123px !important',
    borderRight: '1.6px solid rgba(0, 0, 0, 0.1)',
  },
  container: {
    width: 560,
    height: 280,
  },
  dialogTitle: {
    fontSize: 16,
    color: 'rgba(65,73,83,0.66)',
  },
  dialogContent: {
    padding: '50px !important',
    overflow: 'hidden',
  },
  btn: {
    height: 48,
    width: 220,
    lineHeight: '48px',
    fontSize: 20,
  },
  cancelBtn: {
    color: '#363C46 !important',
    marginLeft: '12px !important',
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },
})
